module.exports = __webpack_public_path__ + "img/screenshot-5.cb63d7b6.png";